import { render } from "./HeroiconsOutlineEmojiSad.vue?vue&type=template&id=32f9f85e"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineEmojiSad.vue"]])

export default __exports__